module.exports = __webpack_public_path__ + "img/mobile.4caeb219.svg";